
<div class="app -clients l-container">
  <div class="chats">
    <chat_card v-for="(chat, i) in chats" :key="i" @chatClick="setActiveChat(i)" :class="{ active: i === activeChat }"
      :chat="chat" :id="i" />
  </div>
  <splash :unreadMessages="unreadMessages.length" v-if="activeChat == -1" />
  <chatroom @updateSelectionStatus="onUpdateSelectionStatus" @messageSent="onMessageSent" v-if="activeChat > -1" :chat="chats[activeChat]" />
</div>
